<script>
  import Router, { replace } from "svelte-spa-router"
  import routes from "./routes.js"
  import './cookie-term.js'

  function routeLoading(event) {
    const detail = event.detail

    // If not hash based, redirect to hash based path
    if (!window.location.hash.startsWith("#/")) {
      // Save query string
      const { search } = window.location

      // Remove any paths and querystrings
      window.history.replaceState(null, "", `${window.location.origin}${window.location.pathname}`)

      // Go to location with querystring
      replace(detail.location + search)
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e)
        })
    }
  }
</script>

<Router {routes} on:routeLoading={routeLoading}/>
